var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlogHeadingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.1092C0 16.3615 0.702379 14.6855 1.95262 13.4498C3.20286 12.214 4.89856 11.5198 6.66667 11.5198C8.43478 11.5198 10.1305 12.214 11.3807 13.4498C12.631 14.6855 13.3333 16.3615 13.3333 18.1092H11.6667C11.6667 16.7984 11.1399 15.5414 10.2022 14.6146C9.26452 13.6878 7.99275 13.1671 6.66667 13.1671C5.34058 13.1671 4.06881 13.6878 3.13113 14.6146C2.19345 15.5414 1.66667 16.7984 1.66667 18.1092H0ZM6.66667 10.6961C3.90417 10.6961 1.66667 8.48453 1.66667 5.75405C1.66667 3.02357 3.90417 0.812012 6.66667 0.812012C9.42917 0.812012 11.6667 3.02357 11.6667 5.75405C11.6667 8.48453 9.42917 10.6961 6.66667 10.6961ZM6.66667 9.04875C8.50833 9.04875 10 7.57437 10 5.75405C10 3.93373 8.50833 2.45936 6.66667 2.45936C4.825 2.45936 3.33333 3.93373 3.33333 5.75405C3.33333 7.57437 4.825 9.04875 6.66667 9.04875Z",
    fill: "#42A8D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogHeadingIcon);
export default __webpack_public_path__ + "static/media/blog_heading_icon.5332cc9cba8fedfdb2ef7aa33debee3c.svg";
export { ForwardRef as ReactComponent };